{
  "internalPortal": {
    "components": {
      "users": {
        "title": "Contacts",
        "subtitle": "Client-side contacts and assigned internal SIB employees",
        "addUser": "Add contact",
        "searchPlaceholder": "Search",
        "spendBrain": "SpendBrain",
        "micrositeAccess": "Microsite access",
        "subTabs": {
          "clientContacts": "Client Contacts ({{count}})",
          "sibEmployees": "SIB Employees ({{count}})",
          "clientContactsTitle": "Client Contacts",
          "sibEmployeesTitle": "SIB Employees"
        },
        "availability": {
          "available": "Available",
          "outOfOffice": "Out of office"
        },
        "previewModal": {
          "title": "Preview contact"
        },
        "form": {
          "title": {
            "add": "Add contact",
            "edit": "Edit contact"
          },
          "fields": {
            "name": "Name",
            "email": "Email",
            "phone": "Phone",
            "status": "Status",
            "lastActive": "Last active",
            "role": "Role",
            "spendBrainAccess": "SpendBrain access"
          },
          "contactStatus": {
            "active": "Available",
            "inactive": "Inactive",
            "out_of_office": "Out of office"
          },
          "success": "Contact saved successfully",
          "error": "Failed to save contact"
        },
        "noData": {
          "withFilters": "No contacts match your search. Try adjusting your search to find what you're looking for.",
          "withoutFilters": "There are currently no records to display in the Contacts tab. No contacts have been linked yet."
        }
      }
    }
  }
}
